export const ROLES = {
  CANDIDATE: 'candidate',
  EMPLOYER: 'employer',
} as const;
